import React from 'react'

const InformationPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <h1 className="text-3xl font-bold text-gray-900">Información</h1>
          <div className="mt-6 bg-white p-8 rounded-lg shadow-md">
            <p className="text-gray-500">
              Página de información - Se implementará en la siguiente fase
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InformationPage